import { render, staticRenderFns } from "./getModel.vue?vue&type=template&id=337044ee&scoped=true&"
import script from "./getModel.vue?vue&type=script&lang=js&"
export * from "./getModel.vue?vue&type=script&lang=js&"
import style0 from "./getModel.vue?vue&type=style&index=0&id=337044ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337044ee",
  null
  
)

export default component.exports